import React, { useContext } from "react";

import { useJsApiLoader } from "@react-google-maps/api";

// import { google_api } from "../../../../config";
import MapaMultiple from "./MapaMultiple";
import { ThemeContext } from "../../../../Theme";

export default function MapaMultipleWrapper(props) {
  const { api_key_maps } = useContext(ThemeContext)
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: api_key_maps,
  });
  if (loadError) return <div>Error al cargar el mapa</div>;
  if (!isLoaded) return <></>;
  return <MapaMultiple {...props} />;
}
